import { remittanceSchema } from '@billing/validation/remittance';

export interface Remittance {
  id: string;
  filename: string;
  siteID: string;
  createdAt: string;
  totalFeeAssessed: string;
  incomeFilePath: string;
  parsedAt: Date | string; // eventually change to string
  claims?: string;
  payorID?: string | null;
  remittanceLines?: RemittanceLine[];
}

export interface RemittanceLine {
  id: string;
  recordCode: string;
  claimNumber: string;
  serviceDate?: string | null;
  tariffCode?: string | null;
  services?: number | null;
  feeSubmitted?: string | number | null;
  amountAssessed: string | number;
  lineType: string;
  eobCodes?: string[] | null;
  raw?: string | null;
}

export type CreateRemittance = Omit<Remittance, 'id' | 'createdAt' | 'claims'>;

export const isRemittance = (obj: any): obj is Remittance => {
  return remittanceSchema.safeParse(obj).success;
};
